import { c as _c } from "react/compiler-runtime";
import { graphql, VariablesOf, ResultOf } from "@/graphql";
import { graphqlClient } from "@/lib/graphql-client";
import { useMutation } from "@tanstack/react-query";
const signupMutation = graphql(`
  mutation signUp($input: SignUpInput!) {
    signUp(input: $input) {
      userId
      companyId
    }
  }
`);
type SignUpVariables = VariablesOf<typeof signupMutation>;
// fallback type definition if GraphQL type extraction fails
export type SignUpInput = SignUpVariables["input"] extends never ? {
  email: string;
  password: string;
  recaptchaToken: string;
} : NonNullable<SignUpVariables["input"]>;
export type SignUpResult = ResultOf<typeof signupMutation>;
export function useSignupMutations(t0) {
  const $ = _c(7);
  const {
    onSuccess,
    onError
  } = t0;
  let t1;
  if ($[0] !== onSuccess) {
    t1 = data => {
      onSuccess(data);
    };
    $[0] = onSuccess;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onError) {
    t2 = error => {
      onError(error);
    };
    $[2] = onError;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      mutationFn: _temp,
      onSuccess: t1,
      onError: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useMutation(t3);
}
async function _temp(input) {
  if (!input.recaptchaToken || typeof input.recaptchaToken !== "string") {
    throw new Error("reCAPTCHA token is missing or invalid");
  }
  return graphqlClient.request(signupMutation, {
    input
  } as SignUpVariables);
}